import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { getMenuIcon } from './menuIcons.js';
import { useChatUnreadCount } from './useChatUnreadCount.js';

export default function SidebarItem({
  iconKey,
  label,
  labelContent,
  to,
  isCollapsed,
  isSubItem = false,
  onNavigate,
  elementRef,
}) {
  const Icon = getMenuIcon(iconKey);
  const hideLabel = isCollapsed && !isSubItem;
  const totalChatUnread = useChatUnreadCount();
  const chatUnreadCount = to === '/chat' ? totalChatUnread : 0;
  const unreadLabel = chatUnreadCount > 0 ? `${label}, ${chatUnreadCount} mensajes sin leer` : label;

  return (
    <NavLink
      to={to}
      ref={elementRef}
      className={({ isActive }) =>
        clsx(
          'sidebar-item group w-full min-w-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))] no-underline',
          hideLabel
            ? 'min-h-[38px] justify-center px-2 py-2'
            : clsx(
                'gap-2.5 px-2.5 py-1.5',
                isSubItem ? 'min-h-[34px] text-[13px]' : 'min-h-[38px] text-sm',
              ),
          isActive && 'active'
        )
      }
      style={{ textDecoration: 'none' }} // ✨ Forzar sin decoración
      title={chatUnreadCount > 0 ? unreadLabel : label}
      aria-label={hideLabel || chatUnreadCount > 0 ? unreadLabel : undefined}
      tabIndex={0}
      onClick={() => {
        onNavigate?.();
      }}
    >
      <>
        {Icon ? (
          <span
            data-testid="sidebar-item-icon"
            className={clsx('relative inline-flex shrink-0', chatUnreadCount > 0 && 'motion-safe:animate-bounce', hideLabel && 'mx-auto')}
          >
            <Icon
              className={clsx(
                'sidebar-icon shrink-0 transition-colors duration-200',
                isSubItem ? 'h-4 w-4' : 'h-[18px] w-[18px]',
              )}
              aria-hidden="true"
            />
            {chatUnreadCount > 0 ? (
              <span className="absolute -right-2.5 -top-1 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 px-1 text-[9px] font-bold leading-none text-white" aria-hidden="true">
                {chatUnreadCount > 99 ? '99+' : chatUnreadCount}
              </span>
            ) : null}
          </span>
        ) : null}
        <span
          className={clsx(
            'sidebar-item-label min-w-0 flex-1 leading-4 font-medium',
            hideLabel ? 'sr-only' : 'block',
            isSubItem ? 'font-normal' : 'font-medium'
          )}
        >
          {labelContent ?? label}
        </span>
      </>
    </NavLink>
  );
}

